import CollapsableMenu from './CollapsableMenu';

export default CollapsableMenu;
